









































































import { PageMode } from '@/main/utils/pageMode';
import { editFactory } from '@/main/pages';
import { NdSklad } from '@/modules/sklad/ndSklad';
import { Ozakazka } from '@/modules/servis/ozakazka';
import { openEdit } from '@/main/router/routerPath';
import { editName } from '@/main/store/listEditTypes';

import { showAlert } from '@/main/utils/notifications';

import ZakazkaSelect from '../zakazka/components/Select.vue';
import { NAME, STOCK_STATUS } from './constants';
import { NAME as ZakazkaName } from '../zakazka/constants';
import { store } from './store/edit';
import { types } from './store/types';
import { apiProvider } from './api';

type NdSkladFilter = {
	VyrobekndOzn: string | null,
	NdNr: string | null,
	SkladOzn: number | null,
	NdText: string | null;
	EanCode: string | null,
};

const precesionFraction:number = 2;
const precesionWhole:number = 0;

export default editFactory(NAME, store).extend({
	components: {
		ZakazkaSelect,
		NdSkladSelectWithCheck: NdSklad.components.SelectWithCheck,
		OzakazkaSelect: Ozakazka.components.Select,
	},
	data() {
		return {
			isCheckNdDisabled: false,
			VydejMjPocBase: 0 as number,
		};
	},
	computed: {
		mutationsMappers(): Record<string, string> {
			return {
				zakazka: `${this.storeUri}/${types.mutations.NDREZ_ZAKAZKA_SELECT_MAPPER}`,
				ndSklad: `${this.storeUri}/${types.mutations.NDREZ_ND_SKLAD_SELECT_MAPPER}`,
				ozakazka: `${this.storeUri}/${types.mutations.NDREZ_OZAKAZKA_SELECT_MAPPER}`,
			};
		},
		zakazkaFilter(): { VyrobekndOzn: string | null } {
			return {
				VyrobekndOzn: this.VyrobekndOzn,
			};
		},
		ndskladFilter(): NdSkladFilter {
			return {
				VyrobekndOzn: this.VyrobekndOzn,
				NdNr: this.NdNr,
				SkladOzn: this.SkladOzn,
				EanCode: this.EanCode,
				NdText: this.Text,
			};
		},
		isOzakazkaDisabled(): boolean {
			const routedFrom = this.$store.state.pageManager.pages[this.$store.state.pageManager.pages.length - 3]?.name ?? null;
			const fromOzakazkaOrZakazka = routedFrom === editName(Ozakazka.name) || routedFrom === editName(ZakazkaName);
			return !!(this.isEditMode && this.ZakazkaId) || this.isViewMode || fromOzakazkaOrZakazka;
		},
		isNdSkladSelectDisabled(): boolean {
			return this.isEditMode || this.isViewMode;
		},
		autofocus(): boolean {
			return !!this.NdNr;
		},
		mnozstvi: {
			get(this: { StavRezerv: number | null, VydejMjPoc: number | null }) {
				if (this.StavRezerv && this.VydejMjPoc) {
					return this.StavRezerv * this.VydejMjPoc;
				}
				return 0;
			},

			set(this: { StavRezerv: number | null, VydejMjPoc: number | null }, val) {
				this.StavRezerv = val / (this.VydejMjPoc ?? 1);
			},
		},
		expendUnitText(): string {
			const unitText = (this.dropdownList.VydejMjId.find((item: any) => item.Value === this.VydejMjId) as any)?.Text ?? '';
			return `${'1'} ${this.SkladMjText} ${'='} ${this.VydejMjPocBase} ${unitText}`;
		},
		mnozstviPrecision(): number {
			const unitText = (this.dropdownList.VydejMjId.find((item: any) => item.Value === this.VydejMjId) as any)?.Text ?? '';
			if (this.SkladMjText === unitText && this.VydejMjPocBase === 1) {
				return precesionWhole;
			}

			return precesionFraction;
		},
		isEUTextVisible(): boolean {
			return (this.Text !== null && this.SkladMjText !== null && this.VydejMjPocBase !== null && this.VydejMjId !== null);
		},
		isEANVisible(): boolean {
			return this.isCreateMode && !this.dmsSys.EnableTaiwanPrp;
		},
	},
	async mounted() {
		if (this.isEditMode || this.isViewMode) {
			this.isCheckNdDisabled = true;
		}
		this.startLoading();
		const { data: partUnitsData } = await NdSklad.apiProvider.getConversionUnitsForPart(this.NdNr!, this.SkladOzn!, this.VyrobekndOzn!);
		if (partUnitsData) {
			this.VydejMjPocBase = partUnitsData.VydejMjPoc;
			this.SkladMjText = partUnitsData.SkladMjText;
		}
		this.endLoading();
		if (this.isQuantityZero) {
			showAlert({
				message: this.LocalizeChyboveHlasky('ZeroQuantity'),
				title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
				options: {
					type: 'info',
				},
			});
		}
	},
	methods: {
		loadedData() {
			if (this.isCreateMode && this.ZaznamId && this.ZaznamId > 0) {
				this.changeToEdit();
			}
		},
		vyrobekndOznChange() {
			this.clearText();
			this.enableCheckNd();
		},
		clearText() {
			this.Text = null;
		},
		enableCheckNd() {
			this.isCheckNdDisabled = false;
		},
		async openViewZakazka() {
			await openEdit(ZakazkaName, PageMode.VIEW, { id: this.ZakazkaId! });
		},
		async validateZakazkaOzakazkaId() {
			if (!this.ZakazkaId && !this.OzakazkaId) {
				this.showErrorAlert({ message: 'ZakazkaNdRezMissZak' });

				return false;
			}
			return true;
		},
		async saveClick() {
			this.startLoading();
			const { data: isPartBlock } = await NdSklad.apiProvider.isPartBlock(this.NdNr!, this.VyrobekndOzn!, this.mnozstvi);
			this.endLoading();
			if (isPartBlock) {
				showAlert({
					message: this.LocalizeChyboveHlasky('PartQuantityIsBlocked'),
					title: this.LocalizeChyboveHlasky('DMS3_ErrorTitle'),
					options: {
						type: 'error',
					},
				});
				return;
			}
			if (this.MrpId === null || this.MrpId <= 0) {
				showAlert({
					message: this.LocalizeChyboveHlasky('PricingDataRequired'),
					title: this.LocalizeChyboveHlasky('DMS3_ErrorTitle'),
					options: {
						type: 'error',
					},
				});
				return;
			}
			if (this.dmsSys.ServicPartVisulizationPrp) {
				this.startLoading();
				const StockStatusDetails = (await apiProvider.isStockAvailable(this.VyrobekndOzn!, this.NdNr!, this.SkladOzn!)).data;
				this.endLoading();
				if (StockStatusDetails === STOCK_STATUS.OUT_OF_STOCK) {
					this.showErrorAlert({ message: 'OutOfStockMassage' });
					return;
				}
				if (StockStatusDetails === STOCK_STATUS.STOCK_SHORTAGE) {
					this.showErrorAlert({ message: 'StockShortage' });
					return;
				}
			}
			if (await this.validateZakazkaOzakazkaId()) {
				await this.saveRezervaceND(true);
			}
		},
		async saveRezervaceND(goBack: boolean) {
			let ProceedWithExpiredPart = true;
			if (this.NdNr !== null) {
				const isPartExpired = await NdSklad.apiProvider.checkIfExpiryAvailable(this.NdNr, this.SkladOzn!);
				if (isPartExpired && isPartExpired.data) {
					ProceedWithExpiredPart = await this.showConfirm({
						message: this.LocalizeChyboveHlasky('PartsExpiryAlert'),
						title: this.LocalizeChyboveHlasky('questionTitle'),
						options: {
							confirmButtonText: this.Localize('Ano'),
							cancelButtonText: this.Localize('Ne'),
						},
					});
				}
			}
			if (ProceedWithExpiredPart) {
				const { data: isPartBlock } = await NdSklad.apiProvider.isPartBlock(this.NdNr!, this.VyrobekndOzn!, this.mnozstvi);
				if (isPartBlock) {
					showAlert({ message: 'PartQuantityIsBlocked' });
					return false;
				}
				const isValid = await this.validate();
				if (!isValid) {
					return false;
				}
			} else {
				return false;
			}
			return (this.isCreateMode) ? this.create(goBack) : this.update(goBack);
		},
		async addRezervaceND() {
			if (await this.validateZakazkaOzakazkaId()) {
				if (await this.saveRezervaceND(false)) {
					if (this.isEditMode) {
						this.changeToCreate({
							OzakazkaId: this.OzakazkaId,
							ZakazkaId: this.ZakazkaId,
							SkladOzn: this.SkladOzn,
							VyrobekndOzn: this.VyrobekndOzn,
						});
						this.enableCheckNd();
					} else {
						this.startLoading();
						this.$store.commit(`${this.storeUri}/${types.mutations.NDREZ_STORE_ZAKAZKA_DATA}`);
						this.resetState();
						await this.default();
						this.$store.commit(`${this.storeUri}/${types.mutations.NDREZ_SET_ZAKAZKA_DATA}`);
						(this.mainForm as any).clearValidate();
						this.endLoading();
					}
				}
			}
		},
	},
});
